/* eslint-disable indent */
/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable no-plusplus */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useOidc, useOidcIdToken } from '@axa-fr/react-oidc';
import { Button, Grid, Backdrop, Badge, CircularProgress, Tooltip, ButtonGroup } from '@mui/material';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { VeoliaIcon } from '@veolia.com/vds-react-components';
import { getSharedProjectsList, setHomeBtnClkFlag, setProjectInfoOpenFlag, get_checkAPI_My_Project, getMyProjectAllData, getSharedProjectAllData, get_checkAPI_shared_Project, setUserDictData, setDbTransactionData, getDbTransactionData, unSavedsetProjectInfoOpenFlag } from '../userData';
import Notification from '../../shared/notification-modal';
import * as validation from '../../shared/validation';
import { getUserListData, getWinflowsFileList, fileConversion, getWinflowsFileContent_units, checkFileExists, dbTransaction } from '../../shared/api/url-helper';
import { test_email, user1_email, defaultModalOptions, defaultUnitValues, region_country_dict } from '../../shared/constantVariable';
import columnDefs from '../../column-defs';
import { JustclearLog } from '../../logger';
import '../../styles/forgot-password.scss';
import {
  MyProjects,
  SharedProjects,
  TemplateLibrary,
  RoMachine,
  DesignFlowsheet,
  AppWizard,
} from '../../shared/assets/images';
import { removeItemFromLocalStorage } from '../../shared/removeElements';
import { removeLocalStorageValue, uploadWinFiles, checkLocalStorageValue } from '../../shared/helper';
import { decrypt_data, encrypt_data } from '../../shared/utils';
import HeaderSection from '../header-section';
import RegionSelection, { Location_Save } from './RegionSelection';
import {externalaccess} from '../../shared/Products';

import './recent-file-form.scss';
// eslint-disable-next-line
let uploadWin_4_File = () => { };
let getUserEmail = '';
let getUserType = '';
// let sharedProjectCount = '';
// let sharedPorjectLoader = '';

const RecentFileListForm = () => {
  const [unreadCount, setUnreadCount] = useState('');
  const { t } = useTranslation();
  const translateObject = t;
  const navigate = useNavigate();
  const [state_loader] = useState({ showResults: true });
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [loading, setLoading] = useState(false);
  const [data, setData] = React.useState([]);
  const [unSavedFilesList, setUnsavedSavedFilesList] = useState([]);
  // Keeps units/region flow from running before DB transaction cache is initialized.
  // Without this guard, external users can hit false negatives in access checks.
  const [dbTransactionReady, setDbTransactionReady] = useState(false);
  const [authData] = useState({});
  const { idTokenPayload } = useOidcIdToken();
  const { isAuthenticated } = useOidc();
  // validation layer start
  const { schema } = columnDefs.forgotpassword.forms;
  const { email } = authData;
  validation.validation({
    schema,
    data: {
      email,
    },
  });
  // @kranthi: Region selection modal state and handlers
  const [visibleRegionSelection, setVisibleRegionSelection] = useState(false);
  // Centralized user resolution so all async flows (file list + units/region) use the same
  // email/type source and avoid timing differences.
  const resolveUserContext = () => {
    const LoginUser = JSON.parse(localStorage.getItem('LoginUser'));
    let userEmail = '';

    if (isAuthenticated) {
      if (!idTokenPayload) {
        window.location.href = '/sign-in';
      } else {
        userEmail = idTokenPayload.sub;
      }
    } else if (LoginUser && LoginUser.isAuthenticated) {
      userEmail = LoginUser.email;
    }

    if (userEmail === test_email && (process.env.REACT_APP_ENV === 'dev')) {
      userEmail = user1_email;
    }

    const userType = userEmail && userEmail.split('@')[1] === 'veolia.com' ? 'internal' : 'external';
    return { userEmail, userType };
  };

  const shouldShowRegionSelection = (userType) => {
    // External access decision depends on dbTransaction payload.
    // Return false until data exists to avoid evaluating with empty context.
    if (userType === 'internal') return true;
    if (userType !== 'external') return false;

    const dbData = getDbTransactionData();
    if (!dbData) return false;

    try {
      return externalaccess(dbData);
    } catch {
      return false;
    }
  };
  // (Legacy geolocationPromptShown flag removed; region modal now triggers directly where needed.)
  const handleCloseRegionSelection = () => {
    setVisibleRegionSelection(false);
  };
  const closeModelOption = () => {
    setModalOption({
      ...defaultModalOptions,
      visible: false,
    });
  };
  const openModelPopUp = (message, title, type) => {
    setModalOption({
      ...defaultModalOptions,
      visible: true,
      title,
      message,
      yesOrNo: false,
      onNo: () => closeModelOption(),
      type
    });
  };
  useEffect(() => {
    const decData = getDbTransactionData();
    if (decData) {
      setUserDictData(decData.users_dict);
      setDbTransactionReady(true);
    } else {
      Promise.all([dbTransaction()]).then((res) => {
        const decData = decrypt_data(res[0].data);
        res[0].data = decData;
        setDbTransactionData(decData); //  set Data globaly used.
        setUserDictData(decData.users_dict);
        setDbTransactionReady(true);
      }).catch(() => {
        openModelPopUp('Failed to fetch DB transaction record', 'Error', 'error');
        setDbTransactionReady(true);
      });
    }
  }, []);
  // this function parse the old win-4 file from XML to JSON and open it into convas
  uploadWin_4_File = async (filename, content, loc, fetchData, setFetchLoading, setVisibleDefaultuints) => {
    // Create a regular expression to match special characters
    // eslint-disable-next-line
    const specialCharsRegex = /[\s~!@#$%^&*()=+{}\[\]';,\.]/g;

    const openFile = (fname, false_, data) => {
      // to do : api call to get the converted file content form s3
      if (loc === 'recentForm')
        navigate(`/main?${fname}`);
      else {
        fetchData(fname, false_, data); // updataing canvas with selected files data
        setFetchLoading(false_); // disableing loading symbol
        setVisibleDefaultuints(false_);
      }
    };

    // Replace all special characters with an empty string.
    filename = filename.replace(specialCharsRegex, '');
    let xmlDocData = '';
    try {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(content, 'text/xml');
      // Check if parsing results in a parsing error
      if (xmlDoc.getElementsByTagName('parsererror').length > 0) {
        throw new Error('Error parsing XML');
      }
      xmlDocData = xmlDoc.documentElement.outerHTML;
    } catch (error) {
      console.error('Error parsing XML:', error);
    }
    if (xmlDocData) {
      const data = {
        'param1': filename,
        'param2': xmlDocData
      };

      fileConversion(data).then((response) => {
        if (response.data && response.data.filepath) {
          const fname = response.data.filepath.split('winflows_file_management/')[1];
          if (response.data.error_status) {
            setModalOption({
              ...defaultModalOptions,
              visible: true,
              title: 'Warning',
              message: response.data.error_status,
              yesOrNo: false,
              onOkay: true,
              // onNo: () => setModalOption(defaultModalOptions),
              onYes: () => openFile(fname, false, response.data)
            });
          }
          else
            // to do : api call to get the converted file content form s3  // eslint-disable-next-line
            if (loc === 'recentForm') {
              // clearInterval(sharedPorjectLoader);
              navigate(`/main?${fname}`);
            } else {
              fetchData(fname, false, response.data); // updataing canvas with selected files data
              setFetchLoading(false); // disableing loading symbol
              setVisibleDefaultuints(false);
            }

        } else if (response.data.status) {
          setModalOption({
            ...defaultModalOptions,
            visible: true,
            title: 'Warning',
            message: response.data.status,
            yesOrNo: false,
            onNo: () => setModalOption(defaultModalOptions)
          });
        }
      }).catch((err) => {
        console.error('network err', err);
      });
    }
  };
  const uploadWinFile = async (event) => {
    if (event.target.files && event.target.files[0]) { // checking file event is existing?
      const file = event.target.files[0];
      const filename = file.name; // This gets the filename
      const reader = new FileReader();
      reader.onload = async (e) => {
        const content = e.target.result;
        if (content.indexOf('<?xml') !== -1) {
          uploadWin_4_File(filename, content, 'recentForm');
        } else {
          const files = event.target.files[0];
          const data = await uploadWinFiles(event);
          let winData = data.target.result;
          if (winData[0] !== '{') {
            winData = decrypt_data(data.target.result);
          }
          const obj = { filename: files.name.split('.win')[0], flag: true, data: winData };
          localStorage.setItem('uploadwinfile', JSON.stringify(obj));
          setTimeout(() => {
            // clearInterval(sharedPorjectLoader);
            navigate('/main');
          }, 100);
        }
      };
      reader.onerror = () => {
        console.error('File reading has failed');
      };
      reader.readAsText(file);
    }
  };
  let recentFileCount = 0;
  const getMyprojectAndSharedProjectFileList = async () => {
    let active = true;
    const userContext = resolveUserContext();
    getUserEmail = userContext.userEmail;
    getUserType = userContext.userType;
    removeItemFromLocalStorage();
    removeLocalStorageValue();
    getUserListData();
    setHomeBtnClkFlag(false);
    getWinflowsFileList(getUserEmail, getUserType)
      .then((response) => {
        response.data = response.data.filter((category) => category.name);
        if (active) {
          setData(response.data);
        }
      }).catch(() => {
        setLoading(false);
      });
    if (localStorage.getItem('shared_file_count')) {
      const arr = JSON.parse(localStorage.getItem('shared_file_count'));
      setUnreadCount(arr);
    } else {
      const data = await getSharedProjectsList(getUserEmail, getUserType, 1, 0, 'shared_file_count');
      setUnreadCount(data);
      localStorage.setItem('shared_file_count', JSON.stringify(data));
    }
    return () => {
      active = false;
    };
  };
  const getUnSavedFiles = () => {
    const files = JSON.parse(localStorage.getItem('savedFiles') || '[]');
    // Only take the first 5 files
    const limitedFiles = files.slice(0, 5);
    setUnsavedSavedFilesList(limitedFiles);
  };

  useEffect(() => {
    const userMailId = sessionStorage.getItem('user_email');
    const getUnits = `units/${userMailId}`;
    // setFetchLoading(true);
    // removeLocalStorageValue();
    localStorage.setItem('globalExitBtn', 'false');
    // setChecked(false);
    // Get default unit set from localStorage or set it to an empty string
    const buildFallbackUnits = () => ({
      'Volume Flow': defaultUnitValues.flow,
      'Pressure': defaultUnitValues.pressure,
      'Temperature': defaultUnitValues.temp,
      'Liquid Volume': defaultUnitValues.volume,
      'Flux': defaultUnitValues.flux,
      'Power': defaultUnitValues.power,
      'type': defaultUnitValues.type
    });

    let response_final;
    try {
      response_final = JSON.parse(localStorage.getItem('default_unit_set_dict')) || buildFallbackUnits();
    } catch (e) {
      response_final = buildFallbackUnits();
    }

    const persistSystemUnits = (units) => {
      // if (!checkLocalStorageValue('system-units')) {
      localStorage.setItem('unit_set_dict', JSON.stringify(units));
      localStorage.setItem('system-units', JSON.stringify({
        temp: units.Temperature,
        pressure: units.Pressure,
        flow: units['Volume Flow'],
        flux: units.Flux,
        power: units.Power,
        volume: units['Liquid Volume'],
        type: units.type
      }));
      // console.log('System units persisted:', units);
      // }
    };

    const mapRegion = (unitsObj) => {
      // Migration logic: previously we stored country; now we standardize on Region.
      // Cases:
      // 1. No country & no Region -> open modal
      // 2. Region present -> trust it (ignore country)
      // 3. Country present, Region missing -> derive Region from mapping
      // 4. Country present but unmapped -> open modal
      // 5. Empty string / null / undefined for country -> treat as missing
      // 6. Region explicitly set to null -> treat as missing (forces user to choose, avoids stale data issues)
      // 7. If Region is derived from Country, persist that choice to cache and session for future visits without needing modal again.
      // 8. If Region is missing and modal is shown, once user selects Region, persist that choice to cache and session as well.
      // This ensures we minimize user prompts while maintaining data integrity and a smooth user experience.
      //  if exeternal user then directly show region selection modal if region is not there in local storage because for external user we are not storing region in local storage as part of security concern, so for external user we are directly showing region selection modal if region is not there in session storage
      //  we are checking for memchem CoE user in the external user because memchem CoE user also have access to see region selection modal and for memchem CoE user we are storing region in local storage as part of user setting so for memchem CoE user also we are checking region in local storage and if region is not there in local storage then we are showing region selection modal
      if (!unitsObj || typeof unitsObj !== 'object') unitsObj = {};

      const hasCountry = !!(unitsObj.country && typeof unitsObj.country === 'string' && unitsObj.country.trim());
      const userContext = resolveUserContext();
      const canShowRegionSelection = shouldShowRegionSelection(userContext.userType);

      // Support both legacy `region` and current `Region`.
      const regionValueRaw = (Object.prototype.hasOwnProperty.call(unitsObj, 'Region') ? unitsObj.Region : unitsObj.region);
      const regionValue = (typeof regionValueRaw === 'string') ? regionValueRaw.trim() : regionValueRaw;
      const hasRegion = !!(typeof regionValue === 'string' && regionValue);
      const isRegionExplicitNull = !!(
        (Object.prototype.hasOwnProperty.call(unitsObj, 'Region') && unitsObj.Region === null)
        || (Object.prototype.hasOwnProperty.call(unitsObj, 'region') && unitsObj.region === null)
      );

      // Normalize: if `region` exists (string) but `Region` does not, promote it.
      if (!Object.prototype.hasOwnProperty.call(unitsObj, 'Region') && typeof unitsObj.region === 'string' && unitsObj.region.trim()) {
        unitsObj.Region = unitsObj.region.trim();
        delete unitsObj.region;
      }

      if (!hasCountry) {
        // remove stale empty country
        if (Object.prototype.hasOwnProperty.call(unitsObj, 'country')) delete unitsObj.country;
        if (!hasRegion) {
          setVisibleRegionSelection(canShowRegionSelection);
        } else {
          // Persist normalized Region in session
          sessionStorage.setItem('Region', unitsObj.Region || regionValue);
        }
        return unitsObj;
      }

      // Country exists; if region already there we trust & persist session
      if (hasRegion) {
        sessionStorage.setItem('Region', unitsObj.Region || regionValue);
        return unitsObj;
      }

      // Special case: Region is explicitly null -> show selection popup
      if (isRegionExplicitNull) {
        if (Object.prototype.hasOwnProperty.call(unitsObj, 'Region')) delete unitsObj.Region;
        if (Object.prototype.hasOwnProperty.call(unitsObj, 'region')) delete unitsObj.region;
        // Need user to pick region
        setVisibleRegionSelection(canShowRegionSelection);
        return unitsObj;
      }

      // Derive region from country list
      const derivedRegion = Object.keys(region_country_dict).find(key => region_country_dict[key].includes(unitsObj.country));
      // console.log('Derived region from country:', derivedRegion);
      if (derivedRegion) {
        delete unitsObj.country;
        unitsObj.Region = derivedRegion;
        sessionStorage.setItem('Region', derivedRegion);
        // Persist region selection when derived from country
        Location_Save(derivedRegion);
      } else {
        // Unmapped country -> ask user to choose
        delete unitsObj.Region; // ensure Region key isn't a misleading stale value
        // Need user to pick region
        setVisibleRegionSelection(canShowRegionSelection);
      }
      return unitsObj;
    };

    const parseUnitsResponse = (raw) => {
      if (!raw || typeof raw !== 'string') return buildFallbackUnits();
      const trimmed = raw.trim();
      if (trimmed.startsWith('{')) {
        try { return JSON.parse(trimmed); } catch { return buildFallbackUnits(); }
      }
      try {
        const token = trimmed.split('"')[1] || trimmed;
        return decrypt_data(token);
      } catch (err) {
        return buildFallbackUnits();
      }
    };

    const loadUnits = async () => {
      if (checkLocalStorageValue('default_unit_set_dict')) {
        // Cached defaults exist. Ensure Region mapping and show popup if missing.
        const mapped = mapRegion({ ...response_final });
        // Persist any mapping adjustments back to cache
        localStorage.setItem('default_unit_set_dict', JSON.stringify(mapped));
        persistSystemUnits(mapped);
        return;
      }
      try {
        const response = await getWinflowsFileContent_units(getUnits);
        const dataStr = response?.data;
        if (typeof dataStr === 'string' && dataStr.trim().toLowerCase() === 'file does not exists') {
          // File absent: directly show region selection modal then migrate fallback units.
          const userContext = resolveUserContext();
          setVisibleRegionSelection(shouldShowRegionSelection(userContext.userType));
          const parsedNoFile = mapRegion(response_final); // mapRegion may also trigger modal if needed
          response_final = parsedNoFile;
          return;
        }
        let parsed = parseUnitsResponse(dataStr);
        parsed = mapRegion(parsed);
        localStorage.setItem('default_unit_set_dict', JSON.stringify(parsed));
        response_final = parsed; // update reference for system units
        // console.log('Units response parsed:', parsed);
        persistSystemUnits(parsed);
      } catch (err) {
        openModelPopUp(t('Failed to fetch Units'), 'Error', 'error');
        persistSystemUnits(response_final); // fallback
      }
    };

    loadUnits();
  // Depend on dbTransactionReady + auth context to avoid race where region logic runs
  // before user type / permissions are available.
  }, [dbTransactionReady, idTokenPayload, isAuthenticated]);
  useEffect(() => {
    getMyprojectAndSharedProjectFileList();
    getUnSavedFiles();
    if (localStorage.getItem('folderPath')) {
      localStorage.removeItem('folderPath');
    }
    if (localStorage.getItem('folderStr')) {
      localStorage.removeItem('folderStr');
    }
    if (localStorage.getItem('folderFileCount')) {
      localStorage.removeItem('folderFileCount');
    }
    localStorage.setItem('renderOne', true);

    JustclearLog();
  }, []);
  const [, setIsHovering] = useState(false);
  const [, setIsHoverId] = useState(0);

  const handleMouseEnter = (j) => {
    setIsHovering(true);
    setIsHoverId(j);
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
  };
  const navigateUrl = (url, flag = false) => {
    setProjectInfoOpenFlag(flag);
    navigate(`/${url}`);
  };
  /*  Get all shared and my-project file START */
  // useEffect(async () => {
  //   const flag_my_project_api = get_checkAPI_My_Project();
  //   if (flag_my_project_api) {
  //     getMyProjectAllData(getUserEmail, getUserType);
  //   }
  //   const flag_shared_project_api = get_checkAPI_shared_Project();
  //   if (flag_shared_project_api) {
  //     getSharedProjectAllData(getUserEmail, getUserType);
  //   }
  // }, []);
  /*  get all shared and my-project file End */

  return (
    <div>
      <Notification
        options={modalOption}
        handleClose={() => setModalOption(defaultModalOptions)}
      />
      <div style={{ backgroundColor: '#FFF', height: '0px' }} />
      <div style={{ backgroundColor: 'white' }}>
        <HeaderSection />
        <Backdrop open={loading} style={{ 'zIndex': 1, backgroundColor: 'transparent' }}>
          <CircularProgress color="inherit" style={{ color: '#4b93f4' }} />
        </Backdrop>
        <div className='landing-wrapper'>
          <div style={{ opacity: loading ? 0 : 1, backgroundColor: '#F2F1F9' }} >
            <div className='sidebar-wrapper'>
              <div className="left-sidebar sidebar sansW4SeLig" style={{ display: state_loader.showResults ? 'block' : 'none', backgroundColor: '#FCFCFC' }}>
                <p className='forground-text-primary L_Bold' style={{ fontFamily: 'fs rufusBld', marginLeft: '28px', marginTop: '24px', marginBottom: '24px' }}>{translateObject('Recent Files')}</p>
                {
                  (data || []).map((obj, i) => {
                    if (obj.name.indexOf('-sharedFile.json') < 0) {
                      if (recentFileCount++ >= 5) {
                        return '';
                      }
                      return (
                        <div key={`aa${Math.random().toString(36).slice(2, 7)}`}>
                          <Tooltip title={obj.name.split('.json')[0]} placement="right" arrow>
                            {/* <Tooltip title={obj.name.split('/').pop().split('.json')[0]} placement="right" arrow> */}
                            <Link
                              className="active sidebar-text-link forground-text-secondary M_Regular Secondary-Hover"
                              key={i}
                              style={{ background: 'none' }}
                              to={`/main?${obj.name}`}
                              onClick={() => setProjectInfoOpenFlag(false)}
                              onMouseOver={() => handleMouseEnter(i)} onMouseOut={handleMouseLeave}>
                              <span className="sidebar-icon d-none"
                              />
                              {/* <span className='json-list-data'>{obj.name.split('.json')[0]}</span> */}
                              {/* This is purpose for showing the fileName in our customized way, and if we remove .split(/) it wont impact anything on file open cases */}
                              {/* <span className='json-list-data'>{obj.name.split('/').pop().split('.json')[0]}</span> */}

                              <span className='json-list-data'>{obj.name.split('/').pop().split('.json')[0]}</span>
                            </Link>
                          </Tooltip>
                        </div>
                      );
                    }
                  })
                }
                <p className='forground-text-primary L_Bold' style={{ fontFamily: 'fs rufusBld', marginLeft: '28px', marginTop: '24px', marginBottom: '24px' }}>AutoSaved Files</p>

                {
                  (unSavedFilesList || []).map((obj, i) => {
                    if (obj.indexOf('-sharedFile.json') < 0) {
                      // Clean filename: keep only last _autoSave_ part
                      //                  let cleanedObj;

                      // if (obj.startsWith('autoSave_')) {
                      //   // Remove everything before the last _autoSave_
                      //   let lastIndex = obj.lastIndexOf('_autoSave_');
                      //   let timestamp = obj.substring(lastIndex + '_autoSave_'.length);
                      //   cleanedObj = 'autoSave_' + timestamp;
                      // } else {
                      //   // Normal case: keep base name and last _autoSave_ part
                      //   let lastIndex = obj.lastIndexOf('_autoSave_');
                      //   cleanedObj = lastIndex !== -1
                      //     ? obj.substring(0, obj.indexOf('_autoSave_')) + obj.substring(lastIndex)
                      //     : obj;
                      // }

                      return (
                        <div key={`aa${Math.random().toString(36).slice(2, 7)}`}>
                          <Tooltip title={obj.split('.json')[0]} placement="right" arrow>
                            {/* <Tooltip title={obj.name.split('/').pop().split('.json')[0]} placement="right" arrow> */}
                            <Link
                              className="active sidebar-text-link forground-text-secondary M_Regular Secondary-Hover"
                              key={i}
                              style={{ background: 'none' }}
                              to={`/main?${obj}`}
                              onClick={() => unSavedsetProjectInfoOpenFlag(true)}
                              onMouseOver={() => handleMouseEnter(i)} onMouseOut={handleMouseLeave}>
                              <span className="sidebar-icon d-none"
                              />
                              {/* <span className='json-list-data'>{obj.name.split('.json')[0]}</span> */}
                              <span className='json-list-data'>{obj.split('.json')[0]}</span>
                            </Link>
                          </Tooltip>
                        </div>
                      );
                    }
                  })
                }
              </div>
              <div className="rufusBld">
                <div className="right-sidebar">
                  <div className='winflow-heading'>
                    <span className="rufusBld forground-text-secondary-text L_Regular">{translateObject('Welcome to')}</span>
                    <h2 className='forground-text-primary XL_heading'>{translateObject('Winflows Design Simulator')}</h2>
                  </div>
                  <Grid container spacing={2} className='winflows_Landing'>
                    <Grid item xs={3} className="sidebar-space" >
                      <Button className='backgroud-primary-default' variant="contained" onClick={() => { navigateUrl('main', true); }}>
                        <img src={DesignFlowsheet} alt={('Design Flowsheet').toLocaleLowerCase()} style={{ margin: '4px' }} />
                        <div className="sansW7Bld forground-text-primary-inverse M_Bold">{translateObject('Design Flowsheet')}</div>
                      </Button>
                    </Grid>
                    <Grid item xs={9} className="sidebar-space">
                      <ButtonGroup variant="contained" aria-label="Basic button group" className='landing_ButtonGroup'>
                        <Button variant="contained" className='backgroud-primary-default' onClick={() => { navigateUrl('preconfig', false); }}><img src={TemplateLibrary} alt={('Template Library').toLocaleLowerCase()} /><div className="sansW7Bld forground-text-primary-inverse M_Bold">{translateObject('Template Library')}</div></Button>
                        <Button variant="contained" className='backgroud-primary-default' onClick={() => { navigateUrl('flowSheetWizard', false); }}><img src={AppWizard} alt={('App wizard').toLocaleLowerCase()} /><div className="sansW7Bld forground-text-primary-inverse M_Bold">{translateObject('Application Wizard')}</div></Button>
                        <Button variant="contained" className='backgroud-primary-default' onClick={() => { navigateUrl('ro-machine', false); }}><img src={RoMachine} alt={('RO-EDI Equipment Selector').toLocaleLowerCase()} /><div className="sansW7Bld forground-text-primary-inverse M_Bold">{translateObject('RO-EDI Equipment Selector')}</div></Button>
                      </ButtonGroup>
                    </Grid>
                    <Grid item xs={12} className="sidebar-space bottom">
                      <ButtonGroup variant="contained" aria-label="Basic button group" className='landing_ButtonGroup'>
                        <Button variant="contained" className='landingpage_projects upload_file_'>
                          <input type="file" id="file-input" accept=".win" onChange={uploadWinFile} />
                          <FileUploadIcon className='fileIcon' color="inherit" style={{ color: '#2c2c2c' }} />
                          <div className="sansW7Bld M_Bold">{translateObject('Open File')}</div>
                        </Button>
                        {/* <Button variant="contained" onClick={() => loadMyPojectData()} className='landingpage_projects background-hover-myproject'>
                          <img src={MyProjects} className='backgroud-primary-default-myProject' alt={('My Projects').toLocaleLowerCase()} />
                          <div className="sansW7Bld M_Bold">{translateObject('My Projects')}</div>
                          {my_poject && (<div className="loader-spinner" />)}
                        </Button> */}
                        <Button variant="contained" onClick={() => navigateUrl('my-projects', false)} className='landingpage_projects background-hover-myproject'>
                          <img src={MyProjects} className='backgroud-primary-default-myProject' alt={('My Projects').toLocaleLowerCase()} />
                          <div className="sansW7Bld M_Bold">{translateObject('My Projects')}</div>
                        </Button>
                        <Button variant="contained" className='shared-button-box' style={{ borderTopLeftRadius: '0px', borderBottomLeftRadius: '0px' }} onClick={() => navigateUrl('shared-projects', false)}>
                          <Badge badgeContent={unreadCount.length}>
                            <img src={SharedProjects} className='backgroud-primary-default-sharedproject' alt={('Received Projects').toLocaleLowerCase()} />
                          </Badge>
                          <div className="sansW7Bld M_Bold">{translateObject('Received Projects')}</div>
                        </Button>
                      </ButtonGroup>
                    </Grid>
                  </Grid>
                  <div
                    onClick={() => navigateUrl('app360', false)}
                    style={{
                      // display: 'flex',
                      display: 'none',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer'
                    }}>
                    <div className='winflows360'>
                      <VeoliaIcon
                        color="#000000"
                        name="360"
                        size={16}
                      />
                      <span className='textwinflows' style={{ marginLeft: '8px', fontSize: '16px' }}>Try Winflows 360!</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
            {visibleRegionSelection && (
        <RegionSelection
          visibleRegionSelection={visibleRegionSelection}
          handleCloseRegionSelection={handleCloseRegionSelection}
          translateObject={translateObject}
          // changeRegion={changeRegion}
        />
      )}
    </div >
  );
};

export default RecentFileListForm;
export { uploadWin_4_File };
